import { FlexBox, ImageThumbnail } from '@airship-platform/jam-web/components';
import { ProposalTemplateTag } from '@airship-platform/airship-proposal';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';
import { ProposalTemplate } from '../../../data-access/proposalTemplate';

type ProposalTemplateOptionCardProps = {
  proposalTemplateTags: ProposalTemplateTag[];
  proposalTemplate: ProposalTemplate;
};

const ProposalTemplateCard: React.FC<ProposalTemplateOptionCardProps> = ({
  proposalTemplateTags,
  proposalTemplate,
}) => {
  const itemsCount = proposalTemplate.options.length;
  const imageUrl = proposalTemplate.options
    .flatMap((o) => o.products)
    .flatMap((m) => m.images)
    .map((i) => i.url)
    .find(Boolean);

  return (
    <FlexBox
      key={proposalTemplate.proposalTemplateId}
      flexDirection={['column', 'row']}
      alignItems={['flex-start', 'flex-start']}
      gap={2}
      width={'100%'}
    >
      <FlexBox gap={2} width={'100%'}>
        <ImageThumbnail
          imageUrl={imageUrl}
          alt={proposalTemplate.name}
          component={Link}
          to={proposalTemplate.proposalTemplateId}
        />
        <FlexBox flexDirection={'column'} gap={2} flex={1}>
          <FlexBox flexDirection={'column'} gap={1}>
            <Typography
              variant="h6"
              component={Link}
              to={proposalTemplate.proposalTemplateId}
              sx={{ textDecoration: 'none', color: 'inherit' }}
            >
              {proposalTemplate.name}
            </Typography>
            <Typography variant="body1" component={'div'}>
              {itemsCount} Option(s)
            </Typography>
          </FlexBox>

          {!!proposalTemplateTags.length && (
            <FlexBox flexWrap={'wrap'} gap={1}>
              {proposalTemplateTags.map((tag) => (
                <Chip
                  key={tag.proposalTemplateTagId}
                  label={tag.name}
                  color="softBlue"
                />
              ))}
            </FlexBox>
          )}

          <Typography variant="body1" component={'div'}>
            {proposalTemplate.summary}
          </Typography>
        </FlexBox>
      </FlexBox>
      <Button
        color="softGold"
        component={Link}
        to={proposalTemplate.proposalTemplateId}
        sx={{
          width: ['100%', 'auto'],
          textTransform: 'none',
        }}
      >
        Select
      </Button>
    </FlexBox>
  );
};

export default ProposalTemplateCard;
